<template>
	<div class="frames-cls">
		<div class="header-cls" v-if="sourceType != 'InfoReview'">
			<div class="svg-cls">
				<svg-icon @click.stop="$emit('emitUnfoldAside')" icon-class="KnowUnfold" />
				<svg-icon @click.stop="handleClose(null, row.uuid)" icon-class="KnowHome" />
			</div>
			<el-divider direction="vertical"></el-divider>
			<div class="title-cls">
				<svg-icon :icon-class="row.type == '1' ? 'KnowArticle' : 'KnowProcess'" /> {{row.q}}
			</div>
			<div class="remark-cls" v-if="row.type == '2'">
				<div v-if="remarkType === 'add' || (remarkType === 'text' && !row.remark)">
					<el-button v-if="row.isEnd != true" @click.stop="remarkType = 'edit'" type="text" icon="el-icon-plus">备注</el-button>
				</div>
				<div v-if="remarkType === 'edit'">
					<el-input v-focus v-model="remark" @keyup.enter.native="handleSubmitRemark" placeholder="输入备注" size="mini" maxlength="10" show-word-limit></el-input>
					<svg-icon @click.stop="handleSubmitRemark" icon-class="KnowDG" />
					<svg-icon @click.stop="remarkType = 'text'" icon-class="KnowClose" />
				</div>
				<div v-if="remarkType === 'text' && row.remark">
					<span class="text">{{row.remark}}</span>
					<svg-icon v-if="row.isEnd != true" @click.stop="remarkType = 'edit'; remark = row.remark;" icon-class="KnowEdit" />
				</div>
			</div>
			<div class="closure-cls" v-if="row.type == '2'">
				<el-button @click.stop="handleCreateSummary" type="primary" icon="el-icon-document" size="mini">生成摘要</el-button>
				<svg-icon v-if="row.isEnd" @click.stop="handleClose(null, row.uuid)" icon-class="KnowClose" />
				<!-- <el-button type="info" v-else @click.stop="handleClose('end')" icon="el-icon-document-checked" size="mini">结束流程</el-button> -->
			</div>
		</div>

		<div class="tabs-cls">
			<el-tabs :class="{'dis':  sourceType == 'InfoReview'}" v-model="activeName" @tab-remove="removeTab" type="card" closable>
				<el-tab-pane :label="item.q" :name="item.uuid" v-for="(item, index) in associatedList" :key="item.uuid">
					<section class="context-cls">
						<Breadcrumb @EditHandleEdit="handleClose(null, row.uuid, item.id)" :currentNode="currentNode" v-if="item.nodeNames" :item="item" />
						<div v-if="item.type == '2'" class="content-cls">
							<div class="cell" :class="{'active': $$(item, 'a', 'aId') === _item.id}" v-for="(_item, _index) in $$(item, 'a', 'themeListTem')" :key="_index">
								<i @click.stop="handleSwitch(_item, index)">{{_index + 1}}</i>
								<div class="title">
									<span class="text">{{_item.name}}</span>
									<span class="appendix" v-if="$$(_item, 'appendixList', 'length') > 0">
										<el-dropdown @command="handleDownLoadFile" trigger="click" placement="bottom-start">
											<i><svg-icon icon-class="KnowAppendix" /> 附件</i>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item v-for="(file, f_index) in $$(_item, 'appendixList')" :key="f_index" :command="file">{{file.name}}</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</span>
									<span class="summary">
										<el-checkbox v-model="_item.isSummary">摘要</el-checkbox>
									</span>
								</div>
								<div class="speak" v-if="_item.isSpeak && _item.speak">
									<svg-icon icon-class="Knowxz" :style="`margin-right: 5px; color: ${$$(item, 'a', 'aId') === _item.id ? '#337EFF' : '#C3C9D0'};font-size: 18px`" />
									<span :style="`color: ${$$(item, 'a', 'aId') === _item.id ? '#337EFF' : '#C3C9D0'}`">推荐话术：</span>
									<span>{{_item.speak}}</span>
								</div>
								<div @click="imageChange($event)" v-html="_item.welfareText" :style="`color: ${$$(item, 'a', 'aId') === _item.id ? '' : '#C3C9D0'};`"></div>
								<div class="welfare" v-if="_item.isJumpOption">
									<svg-icon icon-class="Knowkr" :style="`margin-right: 5px; color: ${$$(item, 'a', 'aId') === _item.id ? '#47B267' : '#C3C9D0'}; font-size: 16px`" />
									<span :style="`color: ${$$(item, 'a', 'aId') === _item.id ? '#47B267' : '#C3C9D0'}`">回答：</span>
									<el-radio-group v-model="_item.value" @change="(ev) => { return handleNext(ev, _index, _item, index)}" :disabled="$$(item, 'a', 'aId') !== _item.id">
										<el-radio v-for="(__item, __index) in _item.jumpOption" :key="__index" :label="__item.id">{{__item.name}}</el-radio>
									</el-radio-group>
								</div>
								<div class="record-list" v-if="_item.isRecord">
									<span class="header" :style="`color: ${$$(item, 'a', 'aId') === _item.id ? '#337EFF' : '#C3C9D0'}`">记录：</span>
									<div class="cell" v-for="(__item, __index) in _item.recordOption" :key="__index">
										<span :style="`color: ${$$(item, 'a', 'aId') === _item.id ? '#3c4353' : '#C3C9D0'}`">{{__item.name}}：</span>
										<el-input
											v-focus
											:autofocus="true"
											v-model="__item.value"
											@blur="isEdit = false"
											type="textarea"
											:rows="2"
											placeholder="此处临时记录会话信息"
											maxlength="1000" show-word-limit>
										</el-input>
									</div>
								</div>
								<div  v-else class="record">
									<span :style="`color: ${$$(item, 'a', 'aId') === _item.id ? '#337EFF' : '#C3C9D0'}`">记录：</span>
									<el-input
										v-focus
										:autofocus="true"
										v-model="_item.recordText"
										@blur="isEdit = false"
										v-if="isEdit && editId == _item.id"
										type="textarea"
										:rows="2"
										placeholder="此处临时记录会话信息"
										maxlength="1000" show-word-limit>
									</el-input>
									<span v-else>
										<span>{{_item.recordText}} </span> 
										<svg-icon @click.stop="isEdit = true;editId = _item.id" icon-class="KnowEdit" />
									</span>
								</div>
								<!--  && count !== $$(item, 'a', 'themeListTem', 'length') -->
								<div class="btns" v-if="!_item.isJumpOption && _item.nextId">
									<el-button type="primary" size="mini" @click.stop="handleNext(_item.nextId, _index, _item, index)" :disabled="$$(item, 'a', 'aId') !== _item.id">下一步</el-button>
								</div>
							</div>
							<div class="end-cls" v-if="isEnd">
								<span class="svg-icon"><svg-icon icon-class="KnowEnd" /> </span>
								<span class="end">
									流程结束
								</span>
							</div>
						</div>
						<div @click="imageChange($event)" v-if="item.type == '1'" class="content-cls" v-html="$$(item, 'a', 'welfareText')"></div>
						<div v-if="sourceType != 'InfoReview'" class="other-cls">
							<div class="help-cls">
								有帮助?
								<svg-icon @click.stop="handleHelp(item, '1')" :class="{'agree': item.isHelp == '1'}" icon-class="Agree" /> 
								<svg-icon @click.stop="handleHelp(item, '2')" :class="{'no-agree': item.isHelp == '2'}" icon-class="NoAgree" />
							</div>
							<div class="view-cls">
								<span>有帮助：{{item.help}}</span>
								<span>查看量：{{item.click}}</span>
								<span>最近修改时间：{{item.lastUpdateTime | formatDate}}</span>
							</div>
						</div>
						<div class="associated-cls" v-if="item.relationQA && sourceType != 'InfoReview'">
							<div class="label-cls">相关{{item.type == '1' ? '知识' : '流程'}}</div>
							<div class="btns-cls">
								<el-button @click.stop="getQaDetail(item.id);" v-for="item in item.relationQA" :key="item.id" type="primary" size="mini" plain round>{{item.q}}</el-button>
							</div>
						</div>
					</section>
					<section class="modal-frame" v-if="centerDialogVisible">
						<div class="container">
							<section class="title-cls">
								<span>流程摘要</span>
								<svg-icon @click.stop="centerDialogVisible=false;" icon-class="KnowClose" />
							</section>
							<Summary :row="row" :associatedList="associatedList" @emitHandleClose="handleClose" @CenterDialogVisible="centerDialogVisible=false;" />
						</div>
					</section>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Breadcrumb from './Breadcrumb';
import Summary from './Summary';
import { generateUUID } from 'utils/index';
export default {
	name: 'KnowledgeInfoPage',
	props: ['row', 'sourceType', 'currentNode'],
	components: {Breadcrumb, Summary},
	computed: {
		...mapGetters([
			'userInfo',
			'StoreSessionCurrentNode',
			'StoreSessionList'
		])
	},
	data() {
		return {
			centerDialogVisible: false,
			list: [],
			activeName: '',
			remarkType: 'add',
			remark: '',
			associatedList: [],
			activeId: '',
			count: 1,
			currentIndex: '',
			isClear: false,
			isEnd: false,
			help: '',
			isEdit: false,
			editId: ''
		}
	},
	watch: {
		row: {
			handler() {
				this.remarkType = this.row.isEnd ? 'text' : this.row.remark ? 'text' : 'add';
				// this.remark = this.StoreSessionCurrentNode.remark;
			},
			immediate:true,
			deep: true
		},
	},
	created() {
		this.getQaDetail(this.row.id);
	},
	methods: {
		...mapMutations({
			'SET_SESSION_LIST_ADD': 'knowService/SET_SESSION_LIST_ADD',
			'SET_SESSION_LIST_EDIT': 'knowService/SET_SESSION_LIST_EDIT',
			'SET_SESSION_LIST_DELETE': 'knowService/SET_SESSION_LIST_DELETE',
			'SET_HISTORY_LIST': 'knowService/SET_HISTORY_LIST',
			'SET_SESSION_CURRENT_NODE': 'knowService/SET_SESSION_CURRENT_NODE',
			'SET_IMAGE_VIEW': 'knowService/SET_IMAGE_VIEW'
		}),
		imageChange(e) {
			if (e.target.tagName == 'IMG') {
				this.SET_IMAGE_VIEW({
					url: e.target.src,
					isShow: true
				});
			}
		},
		handleCreateSummary() {
			this.centerDialogVisible = true;
		},
		handleNext(e, _index, cell, index) {
			console.log(e, _index, cell, index)
			let id = e;
			if(cell.isJumpOption) {
				for(const item of cell.jumpOption) {
					if(e === item.id) {
						id = item.nextId;
					}
				}
			} else {
				id = cell.nextId;
			}
			if(!id) {
				this.isEnd = true;
				return;
			}
			if(this.isClear){
				this.isClear = false;
				this.associatedList[index].a.themeListTem = this.associatedList[index].a.themeListTem.splice(0, this.currentIndex + 1);
				this.count = this.currentIndex + 1;
				setTimeout(() => {
					this.currentIndex = index;
					this.activeId = id;
					this.count = this.count += 1;
					for(const item of this.associatedList[index].a.themeList) {
						if(id === item.id) {
							this.$set(item, "value", '');
							this.$set(item, "isSummary", true);
							this.$set(item, 'recordText', '');
							this.associatedList[index].a['aId'] = id;
							this.associatedList[index].a.themeListTem.push(item);
							if(item.nextId || item.isJumpOption) {
								this.isEnd = false;
							} else {
								this.activeId = '';
								this.isEnd = true;
							}
						}
					}
				}, 100);
			} else {
				setTimeout(() => {
					this.currentIndex = index;
					this.activeId = id;
					this.count = this.count += 1;
					if(!id) {
						this.isEnd = true;
						return;
					}
					for(const item of this.associatedList[index].a.themeList) {
						if(id === item.id) {
							this.$set(item, "value", '');
							this.$set(item, "isSummary", true);
							this.$set(item, 'recordText', '');
							this.associatedList[index].a['aId'] = id;
							this.associatedList[index].a.themeListTem.push(item);
							if(item.nextId || item.isJumpOption) {
								this.isEnd = false;
							} else {
								this.activeId = '';
								this.isEnd = true;
							}
						}
					}
				}, 100);
			}
		},
		handleSwitch(item, index) {
			if(item.id === item?.aId) return;
			this.currentIndex = index;
			// this.activeId = item.id;
			this.associatedList[index].a['aId'] = item.id;
			this.isClear = true;
		},
		handleDownLoadFile(command) {
			let $a = document.createElement('a');
			$a.setAttribute("href", command.url);
			$a.setAttribute("download", command.name);
			$a.setAttribute("target", "_parent");
			let evObj = document.createEvent('MouseEvents');
			evObj.initMouseEvent( 'click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			$a.dispatchEvent(evObj);
		},
		getQaDetail(id) {
			this.$api.apiPostKnowledgeQAInfo({projectId: this.userInfo.brandIdentify, id: id ? id : this.qaId}).then(response => {
				if(response.errcode != 0) return;
				this.knowInfo = response.data;
				this.knowInfo.a = JSON.parse(this.knowInfo.a);
				this.knowInfo['uuid'] = generateUUID();
				this.knowInfo['isHelp'] = '';
				if(this.knowInfo.type == '2') {
					this.$set(this.knowInfo?.a?.themeList[0], 'recordText', '');
					this.$set(this.knowInfo?.a?.themeList[0], "isSummary", true);
					this.$set(this.knowInfo?.a, "themeListTem", []);
					this.knowInfo?.a['themeListTem'].push(this.knowInfo?.a?.themeList[0]);
					this.$set(this.knowInfo?.a, "aId", this.knowInfo?.a?.themeListTem[0]?.['id']);
					// this.activeId = this.knowInfo?.a?.themeListTem[0]?.['id'];
					if(this.knowInfo?.a?.themeListTem[0]?.nextId || this.knowInfo?.a?.themeListTem[0]?.isJumpOption) {
						this.isEnd = false;
					} else {
						this.isEnd = true;
					}

					if(!id) {
						this.knowInfo['createAt'] = dayjs(new Date()).format('HH:mm');
						this.SET_SESSION_LIST_ADD(this.knowInfo);
						this.this.SET_SESSION_CURRENT_NODE(this.knowInfo);
					}
				}
				this.activeName = this.knowInfo.uuid;
				this.associatedList.push(this.knowInfo);
				
			});
		},
		removeTab(targetName) {
			let tabs = this.associatedList;
			let activeName = this.activeName;
			if (activeName === targetName) {
				tabs.forEach((tab, index) => {
					if (tab.uuid === targetName) {
						let nextTab = tabs[index + 1] || tabs[index - 1];
						if (nextTab) {
							activeName = nextTab.uuid;
						}
					}
				});
			}
			this.activeName = activeName;
			this.associatedList = tabs.filter(tab => tab.uuid !== targetName);
		},
		handleSubmitRemark() {
			this.$set(this.row, 'remark', this.remark);
			this.SET_SESSION_LIST_EDIT({
				index: this.StoreSessionCurrentNode.index, 
				row: this.row
			});
			this.remarkType = 'text';
		},
		handleClose(type, uuid, update) {
			if(type === 'end') {
				// this.$confirm("是否结束此会话？","系统提示",{
				// 	confirmButtonText: "确认",
				// 	cancelButtonText: "取消",
				// 	type: "warning"
				// }).then(() => {
					this.SET_SESSION_LIST_DELETE(this.StoreSessionCurrentNode.index);
					let item = this.StoreSessionCurrentNode;
					item.isEnd = true;
					// item.uuid = generateUUID();
					this.SET_HISTORY_LIST(item);
					this.$emit('drawerKnowInfoClose', type, uuid);
				// });
			} else {
				this.$emit('drawerKnowInfoClose', null, uuid, update);
			}
		},
		handleHelp(item, type) {
			if(item.isHelp) return;
			item.isHelp = type;
			this.$api.apiPostKnowledgeSetHelp({
				projectId: item.projectId,
				resourceId: item.resourceId,
				id: item.id,
				type: type
			});
		},
	}
}
</script>

<style lang="scss" scoped>
::v-deep img {
	max-width: 100%;
}
.frames-cls {
	width: 100%;
	height: calc(100vh - 94px);
	position: relative;

	& > .header-cls {
		width: 100%;
		height: 45px;
		border-bottom: solid 1px #dcdfe6;

		& > .svg-cls {
			display: inline-block;
			width: 70px;
			height: 45px;
			text-align: center;
			line-height: 45px;

			& > .svg-icon {
				font-size: 14px;
				width: 35px;
				cursor: pointer;
				color: #566980;

				&:nth-of-type(2) {
					font-size: 15px;
				}
			}
		}

		& > .title-cls {
			display: inline-block;
			vertical-align: top;
			height: 100%;
			max-width: 300px;
			margin-right: 10px;
			font-size: 16px;
			font-weight: 500;
			color: #3C4353;
			line-height: 45px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			margin-left: 8px;
		}

		& > .remark-cls {
			max-width: 250px;
			line-height: 43px;
			display: inline-block;
			vertical-align: top;

			::v-deep .el-input {
				width: 180px;
			}

			& .el-button {
				line-height: 24px;
			}

			& .svg-icon {
				margin-left: 10px;
				color: #337EFF;
				cursor: pointer;

				&:nth-of-type(1) {
					color: #5A5A68;
				}
			}

			& .text {
				font-size: 14px;
				font-weight: 400;
				color: #566980;
				line-height: 45px;
			}
		}

		& > .closure-cls {
			height: 45px;
			float: right;
			text-align: right;
			line-height: 45px;
			padding-right: 20px;
			box-sizing: border-box;

			& > .svg-icon {
				cursor: pointer;
				margin-left: 20px;
			}

			& > .el-button {
				vertical-align: top;
				margin-top: 8px;
			}
		}
	}

	& > .tabs-cls {
		width: 100%;
		height: calc(100% - 50px);
		padding: 7px 10px 0 10px;
		box-sizing: border-box;
		position: relative;
		overflow: hidden;

		::v-deep .el-tabs {
			height: 100%;

			&.dis {
				& .el-tabs__header {
					display: none;
				}
			}

			& .el-tabs__header {
				height: 28px;
				margin-bottom: 0;

				& .el-tabs__nav-wrap {
					height: 28px;
					border: none;

					& .el-tabs__nav-prev, & .el-tabs__nav-next {
						width: 15px;
						height: 26px;
						text-align: center;
						line-height: 26px;
						border-radius: 2px;
						background: #fff;
						border: solid 1px #D8D8D8;
						color: #566980;
						vertical-align: top;
					}

					& .el-tabs__nav-scroll {
						height: 28px;
						line-height: 28px;
						vertical-align: top;
						border: none;

						& .el-tabs__nav {
							height: 28px;
							line-height: 28px;
							border: none;

							& .el-tabs__item {
								height: 28px;
								line-height: 28px;
								background: deeppink;
								vertical-align: top;
								margin-right: 2px;
								background: #F6F7F9;
								border-radius: 4px 4px 0px 0px;
								border: 1px solid #D8D8D8;
								box-sizing: border-box;
								padding: 0 12px;
								font-size: 12px;
								font-weight: 400;
								color: #566980;

								&.is-active {
									color: #337EFF;
									background: #fff;
									border-bottom-color: #fff;
								}

								&:first-child span {
									display: none;
								}

								& span {
									line-height: 13px;
								}
							}
						}
					}
				}
			}

			& .el-tabs__content {
				height: calc(100% - 28px);
				overflow-x: hidden;
				overflow-y: auto;

				& .context-cls {
					width: 100%;
					height: calc(100% - 60px);
					padding: 10px 10px 50px;
					box-sizing: border-box;

					& > .content-cls {
						width: 100%;
						box-sizing: border-box;
						margin-bottom: 20px;

						& > .cell {
							width: 100%;
							padding-left: 34px;
							box-sizing: border-box;
							position: relative;
							margin-bottom: 10px;

							&::before {
								content: "";
								width: 1px;
								height: 100%;
								background: #c8c9cc;
								position: absolute;
								top: 24px;
								left: 12px;
							}

							&:last-child::before {
								display: none;
							}

							& > i {
								display: inline-block;
								text-align: center;
								font-style: normal;
								width: 24px;
								height: 24px;
								background: #c8c9cc;
								color: #fff;
								font-size: 14px;
								line-height: 24px;
								border-radius: 50%;
								position: absolute;
								top: 0;
								left: 0;
								cursor: pointer;
							}

							& > .title {
								font-size: 14px;
								font-weight: bold;
								color: #C3C9D0;
								line-height: 24px;
								margin-bottom: 16px;

								& > .text {
									display: inline-block;
									width: calc(100% - 170px);
								}

								& > .appendix {
									display: inline-block;
									width: 100px;
									text-align: right;
									cursor: pointer;
									& i {
										font-style: normal;
										color: #C3C9D0;
									}
								}

								& > .summary {
									margin-left: 15px;
									float: right;
								}
							}

							& > .speak {
								font-size: 16px;
								font-weight: 400;
								color: #C3C9D0;
								line-height: 24px;
								margin-bottom: 16px;
							}

							& > .welfare {
								margin-bottom: 16px;
								margin-top: 16px;
								& > span {
									font-size: 16px;
									font-weight: 400;
									color: #C3C9D0;
									line-height: 24px;
								}
							}

							& > .record-list {
								margin-top: 16px;

								& > .header {
									font-size: 16px;
									font-weight: 400;
									color: #C3C9D0;
									line-height: 30px;
								}

								& > .cell {
									width: 100%;
									height: auto;
									// padding-left: 16px;
									box-sizing: border-box;
									margin-bottom: 10px;

									& > span {
										font-size: 12px;
										color: #3c4353;
										vertical-align: top;
									}

									& .el-textarea {
										width: calc(100% - 150px);
									}
								}
							}

							& > .record {
								margin-top: 16px;
								& > span {
									font-size: 14px;
									font-weight: 400;
									color: #C3C9D0;
									line-height: 24px;
									vertical-align: top;

									& .svg-icon {
										cursor: pointer;
										color: #C3C9D0;
										font-size: 14px;
										margin-left: 5px;
										position: relative;
										top: 1px;
									}
								}

								::v-deep .el-textarea {
									width: calc(100% - 50px);
								}
							}

							&.active {
								& > i {
									background: #337EFF;
								}

								& > .title {
									color: #3c4353;

									& > .appendix {
										& i {
											color: #337EFF;
										}
									}
								}

								& > .speak {
									color: #3c4353;
								}

								& > .welfare {
									& > span {
										color: #3c4353;
									}
								}

								& > .record {
									& > span {
										color: #6C7E91;

										& .svg-icon {
											color: #337EFF;
										}
									}

									::v-deep .el-textarea {
										width: calc(100% - 50px);
									}
								}
							}


							& .btns {
								margin-top: 13px;
							}
						}

						& .end-cls {
							margin: 20px 0;
							font-size: 16px;
							color: #c0c4cc;
							font-weight: bold;
							padding-left: 35px;
							box-sizing: border-box;
							position: relative;

							& > .svg-icon {
								background: #D7D7D7;
								display: block;
								width: 24px;
								height: 24px;
								border-radius: 50%;
								position: absolute;
								left: 0px;
								font-size: 10px;
								line-height: 22px;
								text-align: center;

								& > .svg-icon {
									color: #fff;
								}
							}

							& > .end {
								display: inline-block;
								height: 20px;
								line-height: 23px;
								vertical-align: top;
								color: #D7D7D7;
								font-size: 14px;
								font-weight: bold;
								margin-right: 21px;
							}

							& > .el-button {
								font-size: 14px;
								padding: 0;
								color: #337EFF;
								line-height: 24px;

								& > .svg-icon {
									color: #337EFF;
								}
							}
						}
					}

					& > .other-cls {
						width: 100%;
						height: 40px;
						text-align: right;
						border-bottom: 1px solid #efefef;
						padding: 0 10px;
						box-sizing: border-box;

						& > div {
							width: 300px;
							display: inline-block;
							vertical-align: top;
							line-height: 40px;
							font-size: 12px;
							font-weight: 400;
							color: #A6AAB8;

							&.help-cls {
								text-align: left;

								& > .svg-icon {
									margin-left: 18px;
									cursor: pointer;
									font-size: 20px;
									&:nth-of-type(1) {
										margin-left: 10px;
									}

									&.agree {
										color: #f29521;
									}

									&.no-agree {
										color: #ff504d;
									}
								}
							}

							&.view-cls {
								width: calc(100% - 300px);
								height: 100%;
								& > span {
									margin-left: 16px;
								}
							}
						}
					}

					& > .associated-cls { 
						width: 100%;
						padding: 0 10px;
						box-sizing: border-box;

						& > .label-cls {
							line-height: 40px;
							font-size: 12px;
							font-weight: 400;
							color: #A6AAB8;
						}

						& > .btns-cls {
							& .el-button {
								height: 24px;
								line-height: 24px;
								padding-top: 0;
								padding-bottom: 0;
								margin-bottom: 10px;
								margin-right: 10px;
								margin-left: 0;
							}
						}
					}
				}
			}
		}

		& .modal-frame {
			// background: rgba(0,0,0,0.3);
			position: fixed;
			top: 0;
			left: 0;
			z-index: 999999999;
			width: 100%;
			height: 100%;

			& > .container {
				width: 500px;
				height: 500px;
				overflow: hidden;
				background: #fff;
				box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.09);
				border-radius: 4px;
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				margin: auto;

				& > .title-cls {
					height: 40px;
					box-sizing: border-box;
					line-height: 40px;
					border-bottom: 1px solid #D8D8D8;
					text-align: center;

					& > span {
						display: block;
						font-size: 16px;
						color: #3C4353;
						font-weight: 500;
						margin-right: 16px;
						letter-spacing: 1px;
						text-align: center;
					}

					& > .svg-icon {
						float: right;
						position: relative;
						top: -28px;
						right: 10px;
						cursor: pointer;
					}
				}

				& > .check-cls {
					width: 100%;
					height: 40px;
					padding: 10px 0;
					box-sizing: border-box;
					text-align: center;
				}

				& > .content-cls {
					width: calc(100% - 40px);
					height: 300px;
					margin: 0 20px;
					border-radius: 4px;
					border: 1px solid #D8D8D8;
					overflow-x: hidden;
					overflow-y: auto;
					padding: 15px;
					box-sizing: border-box;

					& > .cell {
						width: 100%;
						font-size: 14px;
						font-weight: 400;
						color: #6C7E91;
						line-height: 24px;
						border-bottom: 1px dashed #E6E9EF;
						margin-bottom: 10px;
						padding-bottom: 10px;
						box-sizing: border-box;

						&:last-child {
							border: none;
						}
					}
				}

				& > .btns-cls {
					width: 100%;
					text-align: center;
					margin: 20px 0;
				}
			}
		}
	}

	& .dialogImg {
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.3);
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;

		& > .header {
			width: 100%;
			height: 45px;
			line-height: 45px;
			text-align: right;
			padding: 0 20px;
			box-sizing: border-box;

			& > .svg-icon {
				cursor: pointer;
			}
		}

		& > img {
			height: 100%;
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
		}
	}
}


</style>